import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewEncapsulation, inject, output, viewChild } from '@angular/core';
import {Pagination} from '@cdk/models';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {LoginService} from '../../../../main/auth/login/login.service';

import { CdkUsuarioAutocompleteComponent } from '../../../../../@cdk/components/usuario/cdk-usuario-autocomplete/cdk-usuario-autocomplete.component';
import {MatToolbar, MatToolbarRow} from "@angular/material/toolbar";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatAutocompleteTrigger} from "@angular/material/autocomplete";

@Component({
    selector: 'chat-header',
    templateUrl: './chat-header.component.html',
    styleUrls: ['./chat-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbar, MatToolbarRow, FormsModule, ReactiveFormsModule, MatIcon, MatInput, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem, MatAutocompleteTrigger, CdkUsuarioAutocompleteComponent],
    providers: [
        LoginService
    ]
})
export class ChatHeaderComponent implements OnInit
{
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _formBuilder = inject(FormBuilder);
    private _store = inject<Store<fromStore.ChatAppState>>(Store);
    private _loginService = inject(LoginService);


    readonly novaConversaHandler = output<void>();

    readonly pesquisaChatHandler = output<string>();

    readonly criarGrupoHandler = output<void>();

    readonly usuarioElementRef = viewChild<ElementRef>('usuarioInput');

    activeCard: string = 'chat-list';
    usuarioFormPagination: Pagination;
    usuarioForm: FormGroup;
    pesquisaForm: FormGroup;



    /**
     *
     * @param _changeDetectorRef
     * @param _formBuilder
     * @param _store
     * @param _loginService
     */
    constructor()
    {
        this.usuarioForm = this._formBuilder.group({
            usuario: [null, [Validators.required]]
        });
        this.pesquisaForm = this._formBuilder.group({
            pesquisa: [null]
        });

        this.usuarioFormPagination = new Pagination();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.usuarioFormPagination.filter = {'id': 'neq:'+this._loginService.getUserProfile().id};
        this.activeCard = 'chat-list';
    }

    novaConversa() : void
    {
        this.activeCard = 'chat-individual-form';
        setTimeout(() => this.usuarioElementRef().nativeElement.focus());
    }

    checkUsuario(): void
    {
        const value = this.usuarioForm.get('usuario').value;
        if (!value || typeof value !== 'object') {
            this.usuarioForm.get('usuario').setValue(null);
        }
    }

    iniciarChat(): void
    {
        this.checkUsuario();

        if (this.usuarioForm.invalid) {
            return;
        }
        this._store.dispatch(new fromStore.CriarOuRetornar({
            usuario: this.usuarioForm.get('usuario').value,
            populate: [
                'ultimaMensagem',
                'capa'
            ],
            context: {'chat_individual_usuario': this._loginService.getUserProfile()?.id}
        }));
        this.cancelUsuarioForm();
    }

    cancelUsuarioForm(): void
    {
        this.activeCard = 'chat-list';
        this.usuarioForm.reset();
    }

    pesquisar(): void
    {
        this.pesquisaChatHandler.emit(this.pesquisaForm.get('pesquisa').value ?? '');
    }

    criarGrupo(): void
    {
        this.criarGrupoHandler.emit();
    }
}
